

import React, { useState } from 'react';
import PartnerTable from './PartnerTable';
import PartnerForm from './PartnerForm';

const Partners = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingPartner, setEditingPartner] = useState(null);

  const handleAdd = (partnerData) => {
    console.log('Adding new partner:', partnerData);
    // Add your partner creation logic here
  };

  const handleEdit = (partnerData) => {
    setEditingPartner(partnerData);
    setShowForm(true);
  };

  return (
    <>
      {showForm ? (
        <PartnerForm 
          onSuccess={() => {
            setShowForm(false);
            setEditingPartner(null);
          }}
          onCancel={() => {
            setShowForm(false);
            setEditingPartner(null);
          }}
          partnerData={editingPartner}
        />
      ) : (
        <PartnerTable 
          onAddPartner={() => setShowForm(true)} 
          onEditPartner={handleEdit}
        />
      )}
    </>
  );
};

export default Partners;